/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action, computed } from '@ember/object';
import DeviceAttributeCondition, {
  isDeviceExistsCondition,
  SpecialDeviceAttributes,
} from 'cio/app-models/conditions/device-attribute';

interface ValueArgs {
  attributeValues: { value: string; label: string }[];
  condition: DeviceAttributeCondition;
  disabled: boolean;
  size: string;
}

export default class Value extends Component<ValueArgs> {
  @computed('args.condition.name')
  get isDeviceExistsCondition() {
    return isDeviceExistsCondition(this.args.condition.name);
  }

  @computed('args.condition.name')
  get isLastStatusCondition() {
    return this.args.condition.name === SpecialDeviceAttributes._last_status;
  }

  @computed('args.condition.{operator,value}')
  get selectedValue() {
    let { condition } = this.args;
    let selectedValue: any = condition.value;
    if (this.isDeviceExistsCondition) {
      selectedValue = condition.operator === 'exists';
    } else if (this.isLastStatusCondition && condition.operator.endsWith('exists')) {
      selectedValue = 'unused';
    }
    return selectedValue;
  }

  @action
  onValueChange(newValue: string) {
    let value = '';
    if (this.isDeviceExistsCondition) {
      let operator = `${newValue ? '' : '!'}exists`;
      this.args.condition.set('operator', operator);
    } else if (this.isLastStatusCondition) {
      let operator = this.getRightLastStatusOperatorFor(newValue);
      this.args.condition.set('operator', operator);
      if (newValue !== 'unused') {
        value = newValue;
      }
    } else {
      value = newValue;
    }
    this.args.condition.set('value', value);
  }

  getRightLastStatusOperatorFor(newValue: string) {
    let { condition } = this.args;
    let { operator } = condition;
    if (newValue === 'unused') {
      // transitioning from regular condition to unused
      operator = operator === '!eq' ? 'exists' : '!exists';
    } else if (operator.endsWith('exists')) {
      // transitioning from unused to regular condition
      operator = operator === '!exists' ? 'eq' : '!eq';
    }
    return operator;
  }
}
